import React from "react";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import Login from "../../auth/Login";
import Psychographic from "./Psychographic";
const PsychographicIndex = () => {
  return (
    <div>
      <AuthenticatedTemplate>
        <Psychographic />
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </div>
  );
};

export default PsychographicIndex;
